import {initialiseBugsnag} from './configureBugsnag';

// Imported for its side effect so that entries can order it ahead of their
// other imports; a bare call would run after them, since imports hoist.
initialiseBugsnag();
